import React from 'react';

const Icon = {
  LogoMark: (props) => (
    <svg
      width="23"
      height="30"
      viewBox="0 0 23 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_230_2999)">
        <path
          d="M22.4823 14.8406C23.7845 8.08398 21.2792 2.67866 16.8859 2.76568C15.707 2.78986 14.5113 3.20565 13.3688 3.93571C13.2865 3.98889 13.3252 4.09768 13.4148 4.06383C13.8045 3.91637 14.1918 3.83901 14.5718 3.83901C17.6362 3.83901 19.0547 8.83579 17.7428 15.0002C16.4308 21.1646 12.8846 26.1613 9.82019 26.1613C9.44016 26.1613 9.08433 26.084 8.75756 25.9365C8.68252 25.9027 8.5978 26.0115 8.65831 26.0646C9.49099 26.7923 10.5076 27.2105 11.6768 27.2347C16.0338 27.3217 20.8411 21.9164 22.4145 15.1597C22.4266 15.1065 22.4726 14.8962 22.4823 14.843V14.8406Z"
          fill={props.color || 'currentColor'}
        />
        <path
          d="M15.4844 27.1714C14.2523 27.8313 12.9791 28.1842 11.7374 28.1601C6.87925 28.0634 4.28681 22.1552 5.86019 14.9997C5.86261 14.9876 5.87229 14.9393 5.87471 14.9272C7.34642 7.77409 12.4369 1.93847 17.3386 1.84178C18.5924 1.8176 19.7132 2.17054 20.6669 2.8305C20.7347 2.87884 20.8387 2.77006 20.7831 2.70721C19.2557 0.957006 17.1619 -0.0486341 14.6784 -0.00028602C8.47684 0.125419 2.17364 6.77812 0.481654 14.9248C0.479233 14.9369 0.469551 14.9852 0.46713 14.9973C-1.30958 23.144 2.14701 29.8716 8.29529 29.9949C10.757 30.0432 13.2817 29.0376 15.5498 27.2922C15.6297 27.2294 15.574 27.1206 15.4844 27.1689V27.1714Z"
          fill="url(#paint0_linear_230_2999)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_230_2999"
          x1="12.5216"
          y1="3.31639"
          x2="12.5216"
          y2="27.3116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#10AF4D" />
          <stop offset="1" stopColor="#AED42D" />
        </linearGradient>
        <clipPath id="clip0_230_2999">
          <rect width="22.8261" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  LogoText: (props) => (
    <svg
      width="39"
      height="20"
      viewBox="0 0 39 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_230_3000)">
        <path
          d="M3.74271 6.30001V7.44397C3.74271 8.22769 3.84471 8.40918 4.56971 8.40918H12.0981V10.4936H3.99081C1.57047 10.4936 0.826172 9.4404 0.826172 7.01774V4.21559H8.60545V2.08442H0.826172V0H11.5192V6.30001H3.74271ZM13.7549 20H7.4256C4.59176 20 2.93777 18.6773 2.93777 16.1446C2.93777 13.612 4.59176 12.2645 7.4256 12.2645H13.7549C16.5887 12.2645 18.2427 13.5652 18.2427 16.1446C18.2427 18.724 16.5887 20 13.7549 20ZM13.2587 14.4397H7.9218C6.5352 14.4397 5.95631 15.0007 5.95631 16.1446C5.95631 17.2886 6.5352 17.8276 7.9218 17.8276H13.2587C14.6453 17.8276 15.2242 17.2886 15.2242 16.1446C15.2242 15.0007 14.6453 14.4397 13.2587 14.4397Z"
          fill={props.color || 'currentColor'}
        />
        <path
          d="M19.9795 14.7312H27.53V11.1646H24.6548C22.2344 11.1646 21.4901 10.1114 21.4901 7.68871V0H24.5114V3.25038H33.5505V0H36.5718V7.69146C36.5718 10.1141 35.8275 11.1673 33.4072 11.1673H30.5513V14.7339H38.1017V16.9091H19.9822V14.7339L19.9795 14.7312ZM33.5477 5.42555H24.5087V7.9142C24.5087 8.69792 24.7347 8.98941 25.6472 8.98941H32.412C33.3217 8.98941 33.5505 8.69792 33.5505 7.9142V5.42555H33.5477Z"
          fill={props.color || 'currentColor'}
        />
        <path
          d="M17.9834 0H15.4445C15.2626 0 15.1413 0.120995 15.0806 0.362986C15.0228 0.695724 15.0393 1.2072 15.0393 1.2072V10.7906H18.0496V2.60965C18.0744 2.47216 18.0441 1.05321 18.2839 0.390485C18.3638 0.129245 18.2646 0 17.9806 0H17.9834Z"
          fill={props.color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_230_3000">
          <rect
            width="37.2727"
            height="20"
            fill="white"
            transform="translate(0.826172)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  ArrowRight: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.6001 12L3.4001 12"
        stroke="currentColor"
        strokeWidth="2.064"
        strokeMiterlimit="10"
      />
      <path
        d="M9.43994 18.0195L3.41994 11.9995L9.43994 5.97953"
        stroke="currentColor"
        strokeWidth="2.064"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  ArrowBackIosNew: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M640-80 240-480l400-400 71 71-329 329 329 329-71 71Z" />
    </svg>
  ),
  User: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5923 3.02719C14.6801 2.04234 13.406 1.5 11.9998 1.5C10.586 1.5 9.30775 2.03906 8.39978 3.01781C7.48197 4.00734 7.03478 5.35219 7.13978 6.80437C7.34791 9.66937 9.52806 12 11.9998 12C14.4715 12 16.6479 9.66984 16.8593 6.80531C16.9657 5.36625 16.5157 4.02422 15.5923 3.02719ZM20.2498 22.5H3.74978C3.53381 22.5028 3.31993 22.4574 3.1237 22.3672C2.92747 22.2769 2.75383 22.1441 2.6154 21.9783C2.31072 21.6141 2.1879 21.1167 2.27884 20.6137C2.67447 18.4191 3.90916 16.5755 5.84978 15.2812C7.57384 14.1323 9.75775 13.5 11.9998 13.5C14.2418 13.5 16.4257 14.1328 18.1498 15.2812C20.0904 16.575 21.3251 18.4186 21.7207 20.6133C21.8117 21.1162 21.6888 21.6136 21.3842 21.9778C21.2458 22.1437 21.0722 22.2766 20.8759 22.367C20.6797 22.4573 20.4658 22.5028 20.2498 22.5Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Date: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 6H5C3.89543 6 3 6.89543 3 8V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V8C21 6.89543 20.1046 6 19 6Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
      />
      <path
        d="M3 10C3 8.114 3 7.172 3.586 6.586C4.172 6 5.114 6 7 6H17C18.886 6 19.828 6 20.414 6.586C21 7.172 21 8.114 21 10H3Z"
        fill={props.color || 'currentColor'}
      />
      <path
        d="M7 3V6M17 3V6"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10.5 12H7.5C7.22386 12 7 12.2239 7 12.5V13.5C7 13.7761 7.22386 14 7.5 14H10.5C10.7761 14 11 13.7761 11 13.5V12.5C11 12.2239 10.7761 12 10.5 12Z"
        fill={props.color || 'currentColor'}
      />
      <path
        d="M10.5 16H7.5C7.22386 16 7 16.2239 7 16.5V17.5C7 17.7761 7.22386 18 7.5 18H10.5C10.7761 18 11 17.7761 11 17.5V16.5C11 16.2239 10.7761 16 10.5 16Z"
        fill={props.color || 'currentColor'}
      />
      <path
        d="M16.5 12H13.5C13.2239 12 13 12.2239 13 12.5V13.5C13 13.7761 13.2239 14 13.5 14H16.5C16.7761 14 17 13.7761 17 13.5V12.5C17 12.2239 16.7761 12 16.5 12Z"
        fill={props.color || 'currentColor'}
      />
      <path
        d="M16.5 16H13.5C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H16.5C16.7761 18 17 17.7761 17 17.5V16.5C17 16.2239 16.7761 16 16.5 16Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Delete: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0002 3.33301C6.31766 3.33301 3.3335 6.31801 3.3335 9.99967C3.3335 13.6813 6.31766 16.6663 10.0002 16.6663C13.6827 16.6663 16.6668 13.6813 16.6668 9.99967C16.6668 6.31801 13.6827 3.33301 10.0002 3.33301ZM13.0893 11.9105C13.2456 12.0668 13.3334 12.2787 13.3334 12.4997C13.3334 12.7207 13.2456 12.9326 13.0893 13.0888C12.9331 13.2451 12.7211 13.3329 12.5002 13.3329C12.2792 13.3329 12.0673 13.2451 11.911 13.0888L10.0002 11.178L8.08933 13.0888C8.01212 13.1665 7.92032 13.2281 7.81921 13.2702C7.7181 13.3122 7.60967 13.3339 7.50016 13.3339C7.39066 13.3339 7.28223 13.3122 7.18112 13.2702C7.08001 13.2281 6.98821 13.1665 6.911 13.0888C6.75477 12.9326 6.66701 12.7206 6.66701 12.4997C6.66701 12.2787 6.75477 12.0668 6.911 11.9105L8.82183 9.99967L6.911 8.08884C6.75474 7.93258 6.66696 7.72066 6.66696 7.49967C6.66696 7.27869 6.75474 7.06676 6.911 6.91051C7.06725 6.75425 7.27918 6.66647 7.50016 6.66647C7.72114 6.66647 7.93307 6.75425 8.08933 6.91051L10.0002 8.82134L11.911 6.91051C12.0673 6.75425 12.2792 6.66647 12.5002 6.66647C12.7211 6.66647 12.9331 6.75425 13.0893 6.91051C13.2456 7.06676 13.3334 7.27869 13.3334 7.49967C13.3334 7.72066 13.2456 7.93258 13.0893 8.08884L11.1785 9.99967L13.0893 11.9105Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Edit: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M120-120v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm584-528 56-56-56-56-56 56 56 56Z" />
    </svg>
  ),
  Construction: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.9581 20.0001L13.4061 14.4481L14.4671 13.3871L20.0191 18.9391L18.9581 20.0001ZM5.06215 20.0001L4.00015 18.9391L10.9581 11.9811L7.98815 9.03114L7.44215 9.57714L6.49415 8.61014V10.4101L5.94815 10.9561L3.32715 8.33514L3.87315 7.78914H5.67315L4.71215 6.84614L6.87715 4.68114C7.10782 4.45047 7.36048 4.27914 7.63515 4.16714C7.90915 4.05581 8.20148 4.00014 8.51215 4.00014C8.82215 4.00014 9.11448 4.05581 9.38915 4.16714C9.66382 4.27847 9.91615 4.44981 10.1461 4.68114L8.50015 6.32714L9.59615 7.42314L9.05015 7.96914L12.0201 10.9191L14.5771 8.36114C14.4205 8.13981 14.3118 7.91314 14.2511 7.68114C14.1905 7.44914 14.1601 7.19447 14.1601 6.91714C14.1601 6.10047 14.4431 5.40914 15.0091 4.84314C15.5751 4.27714 16.2665 3.99414 17.0831 3.99414C17.2565 3.99414 17.4231 4.00647 17.5831 4.03114C17.7445 4.05514 17.9035 4.10447 18.0601 4.17914L15.9891 6.25014L17.7501 8.01114L19.8211 5.94114C19.8991 6.09714 19.9495 6.25547 19.9721 6.41614C19.9948 6.57747 20.0061 6.74447 20.0061 6.91714C20.0061 7.73381 19.7228 8.42514 19.1561 8.99114C18.5908 9.55781 17.8998 9.84114 17.0831 9.84114C16.8058 9.84114 16.5511 9.81147 16.3191 9.75214C16.0871 9.69281 15.8605 9.58314 15.6391 9.42314L5.06215 20.0001Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Plus: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Alert: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.99997 10V13C5.99996 13.1555 5.96366 13.3089 5.89397 13.448L4.61997 16H19.384L18.108 13.448C18.0376 13.3091 18.0006 13.1557 18 13V10C18 8.4087 17.3678 6.88258 16.2426 5.75736C15.1174 4.63214 13.5913 4 12 4C10.4087 4 8.88255 4.63214 7.75733 5.75736C6.63211 6.88258 5.99997 8.4087 5.99997 10ZM7.99997 18H2.99997C2.82944 18 2.66174 17.9564 2.51282 17.8733C2.3639 17.7902 2.2387 17.6704 2.14911 17.5253C2.05952 17.3802 2.00853 17.2146 2.00098 17.0443C1.99343 16.8739 2.02957 16.7045 2.10597 16.552L3.99997 12.764V10C3.99997 7.87827 4.84282 5.84344 6.34311 4.34315C7.8434 2.84285 9.87824 2 12 2C14.1217 2 16.1565 2.84285 17.6568 4.34315C19.1571 5.84344 20 7.87827 20 10V12.764L21.894 16.552C21.9704 16.7045 22.0065 16.8739 21.999 17.0443C21.9914 17.2146 21.9404 17.3802 21.8508 17.5253C21.7612 17.6704 21.636 17.7902 21.4871 17.8733C21.3382 17.9564 21.1705 18 21 18H16C16 19.0609 15.5785 20.0783 14.8284 20.8284C14.0782 21.5786 13.0608 22 12 22C10.9391 22 9.92169 21.5786 9.17154 20.8284C8.42139 20.0783 7.99997 19.0609 7.99997 18ZM14 18H9.99997C9.99997 18.5304 10.2107 19.0391 10.5858 19.4142C10.9608 19.7893 11.4695 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Phone: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6292 13.8914L17.0852 13.4384L16.0262 12.3744L15.5722 12.8274L16.6292 13.8914ZM18.6142 13.2484L20.5252 14.2874L21.2402 12.9694L19.3302 11.9314L18.6142 13.2484ZM20.8922 16.3514L19.4722 17.7644L20.5292 18.8274L21.9492 17.4154L20.8922 16.3514ZM18.6062 18.2184C17.1562 18.3544 13.4062 18.2334 9.34417 14.1954L8.28617 15.2584C12.7182 19.6654 16.9372 19.8814 18.7462 19.7124L18.6062 18.2184ZM9.34417 14.1954C5.47317 10.3454 4.83117 7.10845 4.75117 5.70345L3.25317 5.78845C3.35317 7.55645 4.14817 11.1444 8.28617 15.2584L9.34417 14.1954ZM10.7192 8.01545L11.0062 7.72945L9.95017 6.66645L9.66317 6.95145L10.7192 8.01545ZM11.2342 4.09445L9.97417 2.41045L8.77317 3.31045L10.0332 4.99345L11.2342 4.09445ZM5.73317 2.04345L4.16317 3.60345L5.22117 4.66745L6.79017 3.10745L5.73317 2.04345ZM10.1912 7.48345C9.66117 6.95145 9.66117 6.95145 9.66117 6.95345H9.65917L9.65617 6.95745C9.60865 7.00536 9.5661 7.05796 9.52917 7.11445C9.47517 7.19445 9.41617 7.29945 9.36617 7.43245C9.24445 7.77577 9.21412 8.14486 9.27817 8.50345C9.41217 9.36845 10.0082 10.5114 11.5342 12.0294L12.5922 10.9654C11.1632 9.54545 10.8232 8.68145 10.7602 8.27345C10.7302 8.07945 10.7612 7.98345 10.7702 7.96145C10.7762 7.94811 10.7762 7.94611 10.7702 7.95545C10.7613 7.96925 10.7512 7.98229 10.7402 7.99445L10.7302 8.00445L10.7202 8.01345L10.1912 7.48345ZM11.5342 12.0294C13.0612 13.5474 14.2102 14.1394 15.0762 14.2714C15.5192 14.3394 15.8762 14.2854 16.1472 14.1844C16.299 14.1289 16.4408 14.0492 16.5672 13.9484L16.6172 13.9034L16.6242 13.8974L16.6272 13.8944L16.6282 13.8924C16.6282 13.8924 16.6292 13.8914 16.1002 13.3594C15.5702 12.8274 15.5732 12.8264 15.5732 12.8264L15.5752 12.8244L15.5772 12.8224L15.5832 12.8174L15.5932 12.8074L15.6312 12.7774C15.6405 12.7714 15.6382 12.7721 15.6242 12.7794C15.5992 12.7884 15.5012 12.8194 15.3042 12.7894C14.8902 12.7254 14.0202 12.3854 12.5922 10.9654L11.5342 12.0294ZM9.97417 2.40945C8.95417 1.04945 6.95017 0.833448 5.73317 2.04345L6.79017 3.10745C7.32217 2.57845 8.26617 2.63345 8.77317 3.31045L9.97417 2.40945ZM4.75217 5.70445C4.73217 5.35845 4.89117 4.99645 5.22117 4.66845L4.16217 3.60445C3.62517 4.13845 3.20217 4.89445 3.25317 5.78845L4.75217 5.70445ZM19.4722 17.7644C19.1982 18.0384 18.9022 18.1924 18.6072 18.2194L18.7462 19.7124C19.4812 19.6434 20.0822 19.2734 20.5302 18.8284L19.4722 17.7644ZM11.0062 7.72945C11.9912 6.75045 12.0642 5.20345 11.2352 4.09545L10.0342 4.99445C10.4372 5.53345 10.3772 6.24045 9.94917 6.66745L11.0062 7.72945ZM20.5262 14.2884C21.3432 14.7324 21.4702 15.7784 20.8932 16.3524L21.9512 17.4154C23.2912 16.0824 22.8782 13.8594 21.2412 12.9704L20.5262 14.2884ZM17.0852 13.4394C17.4692 13.0574 18.0872 12.9634 18.6152 13.2494L19.3312 11.9324C18.2472 11.3424 16.9032 11.5054 16.0272 12.3754L17.0852 13.4394Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  PhoneFill: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4142 16.6006C11.3342 16.5608 8.27349 16.1378 5.06799 12.9331C1.86324 9.72758 1.44099 6.66758 1.40049 5.58683C1.34049 3.93983 2.60199 2.34008 4.05924 1.71533C4.23473 1.63956 4.42689 1.61071 4.61689 1.63161C4.80689 1.65252 4.98819 1.72246 5.14299 1.83458C6.34299 2.70908 7.17099 4.03208 7.88199 5.07233C8.03843 5.30088 8.10532 5.57899 8.06991 5.85368C8.0345 6.12837 7.89928 6.38043 7.68999 6.56183L6.22674 7.64858C6.15605 7.69963 6.10629 7.7746 6.0867 7.85958C6.06711 7.94455 6.07903 8.03374 6.12024 8.11058C6.45174 8.71283 7.04124 9.60983 7.71624 10.2848C8.39124 10.9598 9.33099 11.5883 9.97524 11.9573C10.056 12.0027 10.1511 12.0154 10.2409 11.9928C10.3308 11.9702 10.4085 11.914 10.4582 11.8358L11.4107 10.3861C11.5859 10.1535 11.8442 9.99763 12.1316 9.95122C12.4191 9.90481 12.7133 9.97141 12.9527 10.1371C14.008 10.8676 15.2395 11.6813 16.141 12.8356C16.2622 12.9915 16.3393 13.1771 16.3643 13.3731C16.3892 13.569 16.361 13.768 16.2827 13.9493C15.655 15.4141 14.0665 16.6613 12.4142 16.6006Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Time: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99984 1.66699C14.6023 1.66699 18.3332 5.39783 18.3332 10.0003C18.3332 14.6028 14.6023 18.3337 9.99984 18.3337C5.39734 18.3337 1.6665 14.6028 1.6665 10.0003C1.6665 5.39783 5.39734 1.66699 9.99984 1.66699ZM9.99984 3.33366C8.23173 3.33366 6.53603 4.03604 5.28579 5.28628C4.03555 6.53652 3.33317 8.23222 3.33317 10.0003C3.33317 11.7684 4.03555 13.4641 5.28579 14.7144C6.53603 15.9646 8.23173 16.667 9.99984 16.667C11.7679 16.667 13.4636 15.9646 14.7139 14.7144C15.9641 13.4641 16.6665 11.7684 16.6665 10.0003C16.6665 8.23222 15.9641 6.53652 14.7139 5.28628C13.4636 4.03604 11.7679 3.33366 9.99984 3.33366ZM9.99984 5.00033C10.2039 5.00035 10.401 5.07529 10.5535 5.21092C10.706 5.34655 10.8035 5.53345 10.8273 5.73616L10.8332 5.83366V9.65533L13.089 11.9112C13.2385 12.0611 13.3252 12.2624 13.3317 12.474C13.3382 12.6856 13.2638 12.8918 13.1238 13.0506C12.9838 13.2094 12.7885 13.3089 12.5778 13.329C12.367 13.3491 12.1565 13.2882 11.989 13.1587L11.9107 13.0895L9.41067 10.5895C9.28115 10.4599 9.19797 10.2912 9.174 10.1095L9.1665 10.0003V5.83366C9.1665 5.61264 9.2543 5.40068 9.41058 5.2444C9.56686 5.08812 9.77882 5.00033 9.99984 5.00033Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Stop: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 16V8C6 7.45 6.196 6.97933 6.588 6.588C6.98 6.19667 7.45067 6.00067 8 6H16C16.55 6 17.021 6.196 17.413 6.588C17.805 6.98 18.0007 7.45067 18 8V16C18 16.55 17.8043 17.021 17.413 17.413C17.0217 17.805 16.5507 18.0007 16 18H8C7.45 18 6.97933 17.8043 6.588 17.413C6.19667 17.0217 6.00067 16.5507 6 16Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Play: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.409 9.35331C20.8893 9.60872 21.291 9.99 21.5712 10.4563C21.8514 10.9226 21.9994 11.4563 21.9994 12.0003C21.9994 12.5443 21.8514 13.078 21.5712 13.5443C21.291 14.0106 20.8893 14.3919 20.409 14.6473L7.597 21.6143C5.534 22.7373 3 21.2773 3 18.9683V5.03331C3 2.72331 5.534 1.26431 7.597 2.38531L20.409 9.35331Z"
        stroke="white"
        strokeWidth="1.5"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Pause: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 19C15.45 19 14.9793 18.8043 14.588 18.413C14.1967 18.0217 14.0007 17.5507 14 17V7C14 6.45 14.196 5.97933 14.588 5.588C14.98 5.19667 15.4507 5.00067 16 5C16.5493 4.99934 17.0203 5.19533 17.413 5.588C17.8057 5.98067 18.0013 6.45134 18 7V17C18 17.55 17.8043 18.021 17.413 18.413C17.0217 18.805 16.5507 19.0007 16 19ZM8 19C7.45 19 6.97933 18.8043 6.588 18.413C6.19667 18.0217 6.00067 17.5507 6 17V7C6 6.45 6.196 5.97933 6.588 5.588C6.98 5.19667 7.45067 5.00067 8 5C8.54933 4.99934 9.02033 5.19533 9.413 5.588C9.80567 5.98067 10.0013 6.45134 10 7V17C10 17.55 9.80433 18.021 9.413 18.413C9.02167 18.805 8.55067 19.0007 8 19Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Circle: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  UserLogin: (props) => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.578 15.8391C20.7998 14.8778 21.6916 13.5597 22.1293 12.068C22.567 10.5763 22.529 8.98527 22.0203 7.51624C21.5117 6.04722 20.5579 4.77325 19.2915 3.87157C18.0251 2.9699 16.5092 2.48535 14.9546 2.48535C13.4 2.48535 11.8841 2.9699 10.6177 3.87157C9.35135 4.77325 8.3975 6.04722 7.88889 7.51624C7.38027 8.98527 7.34218 10.5763 7.7799 12.068C8.21763 13.5597 9.10942 14.8778 10.3312 15.8391C8.23766 16.6778 6.41098 18.069 5.04589 19.8642C3.6808 21.6595 2.82848 23.7915 2.57978 26.033C2.56178 26.1967 2.57619 26.3623 2.62219 26.5204C2.66818 26.6785 2.74486 26.8259 2.84786 26.9544C3.05586 27.2138 3.35839 27.38 3.68891 27.4163C4.01942 27.4527 4.35084 27.3563 4.61026 27.1483C4.86968 26.9403 5.03584 26.6377 5.0722 26.3072C5.34584 23.8711 6.50743 21.6212 8.33504 19.9874C10.1626 18.3536 12.5281 17.4505 14.9795 17.4505C17.431 17.4505 19.7964 18.3536 21.624 19.9874C23.4516 21.6212 24.6132 23.8711 24.8869 26.3072C24.9208 26.6134 25.0669 26.8962 25.297 27.1011C25.5272 27.3059 25.825 27.4182 26.1331 27.4163H26.2702C26.5968 27.3787 26.8954 27.2136 27.1008 26.9568C27.3063 26.7 27.4019 26.3725 27.3668 26.0455C27.117 23.7976 26.26 21.6601 24.8879 19.8621C23.5158 18.0641 21.6803 16.6734 19.578 15.8391ZM14.9546 14.9543C13.9687 14.9543 13.0049 14.6619 12.1852 14.1142C11.3654 13.5664 10.7265 12.7879 10.3492 11.877C9.97194 10.9662 9.87323 9.96391 10.0656 8.99695C10.2579 8.02999 10.7327 7.14177 11.4298 6.44463C12.1269 5.74749 13.0152 5.27274 13.9821 5.0804C14.9491 4.88805 15.9514 4.98677 16.8622 5.36406C17.7731 5.74135 18.5516 6.38027 19.0993 7.20002C19.6471 8.01977 19.9394 8.98353 19.9394 9.96944C19.9394 11.2915 19.4143 12.5594 18.4794 13.4942C17.5446 14.4291 16.2767 14.9543 14.9546 14.9543Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  PassWord: (props) => (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.38184 19.0576C2.38184 15.6893 2.38184 14.0039 3.4288 12.9581C4.47457 11.9111 6.15996 11.9111 9.52835 11.9111H19.057C22.4254 11.9111 24.1108 11.9111 25.1566 12.9581C26.2035 14.0039 26.2035 15.6893 26.2035 19.0576C26.2035 22.426 26.2035 24.1114 25.1566 25.1572C24.1108 26.2042 22.4254 26.2042 19.057 26.2042H9.52835C6.15996 26.2042 4.47457 26.2042 3.4288 25.1572C2.38184 24.1114 2.38184 22.426 2.38184 19.0576Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
      />
      <path
        d="M7.14648 11.911V9.52884C7.14648 7.63346 7.89942 5.81572 9.23965 4.47549C10.5799 3.13526 12.3976 2.38232 14.293 2.38232C16.1884 2.38232 18.0061 3.13526 19.3463 4.47549C20.6866 5.81572 21.4395 7.63346 21.4395 9.52884V11.911"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.52832 19.0576H9.53904M14.2819 19.0576H14.2927M19.0463 19.0576H19.057"
        stroke={props.color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Search: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '20'}
      height={props.height || '20'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
    </svg>
  ),
  BottomArrow: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 10L12 15L7 10"
        stroke={props.color || 'currentColor'}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Close: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 14.1216L17.3031 19.4246C17.5845 19.706 17.9661 19.8641 18.3641 19.8641C18.762 19.8641 19.1437 19.706 19.4251 19.4246C19.7065 19.1432 19.8646 18.7616 19.8646 18.3636C19.8646 17.9657 19.7065 17.584 19.4251 17.3026L14.1201 11.9996L19.4241 6.69662C19.5634 6.55729 19.6738 6.39189 19.7492 6.20987C19.8245 6.02785 19.8633 5.83277 19.8632 5.63577C19.8632 5.43877 19.8243 5.24371 19.7489 5.06172C19.6735 4.87974 19.5629 4.71439 19.4236 4.57512C19.2843 4.43586 19.1189 4.3254 18.9368 4.25005C18.7548 4.1747 18.5597 4.13595 18.3627 4.13599C18.1657 4.13604 17.9707 4.17489 17.7887 4.25032C17.6067 4.32575 17.4414 4.43629 17.3021 4.57562L12.0001 9.87862L6.69709 4.57562C6.55879 4.43229 6.39333 4.31794 6.21036 4.23924C6.02739 4.16055 5.83058 4.11907 5.63141 4.11725C5.43224 4.11543 5.23471 4.15329 5.05033 4.22862C4.86595 4.30395 4.69842 4.41526 4.55752 4.55603C4.41661 4.6968 4.30515 4.86422 4.22964 5.04853C4.15414 5.23284 4.11609 5.43034 4.11773 5.62951C4.11936 5.82868 4.16065 6.02553 4.23917 6.20857C4.3177 6.39161 4.43189 6.55718 4.57509 6.69562L9.88009 11.9996L4.57609 17.3036C4.43289 17.4421 4.3187 17.6076 4.24017 17.7907C4.16165 17.9737 4.12036 18.1706 4.11873 18.3697C4.11709 18.5689 4.15514 18.7664 4.23064 18.9507C4.30615 19.135 4.41761 19.3024 4.55852 19.4432C4.69942 19.584 4.86695 19.6953 5.05133 19.7706C5.23571 19.846 5.43324 19.8838 5.63241 19.882C5.83158 19.8802 6.02839 19.8387 6.21136 19.76C6.39433 19.6813 6.55979 19.567 6.69809 19.4236L12.0001 14.1216Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Refresh: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
    </svg>
  ),
  Sad: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 13C13.267 13 14.427 13.473 15.308 14.25C15.5069 14.4256 15.6279 14.673 15.6444 14.9378C15.6609 15.2026 15.5716 15.4631 15.396 15.662C15.2204 15.8609 14.973 15.9819 14.7082 15.9984C14.4434 16.0149 14.1829 15.9256 13.984 15.75C13.4361 15.2668 12.7306 15.0001 12 15C11.239 15 10.545 15.282 10.016 15.75C9.91751 15.8369 9.80287 15.9035 9.67863 15.9461C9.5544 15.9886 9.42299 16.0063 9.29192 15.9981C9.16085 15.9899 9.03268 15.9559 8.91474 15.8982C8.79679 15.8404 8.69137 15.76 8.6045 15.6615C8.51763 15.563 8.45101 15.4484 8.40845 15.3241C8.36588 15.1999 8.3482 15.0685 8.35642 14.9374C8.36464 14.8064 8.39859 14.6782 8.45634 14.5602C8.51409 14.4423 8.59451 14.3369 8.693 14.25C9.60633 13.4445 10.7822 13 12 13ZM8.5 8C8.89782 8 9.27936 8.15804 9.56066 8.43934C9.84196 8.72064 10 9.10218 10 9.5C10 9.89782 9.84196 10.2794 9.56066 10.5607C9.27936 10.842 8.89782 11 8.5 11C8.10218 11 7.72064 10.842 7.43934 10.5607C7.15804 10.2794 7 9.89782 7 9.5C7 9.10218 7.15804 8.72064 7.43934 8.43934C7.72064 8.15804 8.10218 8 8.5 8ZM15.5 8C15.8978 8 16.2794 8.15804 16.5607 8.43934C16.842 8.72064 17 9.10218 17 9.5C17 9.89782 16.842 10.2794 16.5607 10.5607C16.2794 10.842 15.8978 11 15.5 11C15.1022 11 14.7206 10.842 14.4393 10.5607C14.158 10.2794 14 9.89782 14 9.5C14 9.10218 14.158 8.72064 14.4393 8.43934C14.7206 8.15804 15.1022 8 15.5 8Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Check: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.25012 18.7186L2.55762 13.0261L5.15178 10.432L8.25012 13.5395L17.3068 4.47363L19.9009 7.0678L8.25012 18.7186Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Caution: (props) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1009_1993)">
        <path
          d="M2.63724 15.3632C1.77765 14.533 1.09201 13.5399 0.62033 12.4419C0.148649 11.3438 -0.0996274 10.1629 -0.110012 8.96785C-0.120396 7.77284 0.107319 6.58772 0.559847 5.48166C1.01238 4.37559 1.68065 3.37072 2.52569 2.52569C3.37072 1.68065 4.37559 1.01238 5.48166 0.559847C6.58772 0.107319 7.77284 -0.120396 8.96785 -0.110012C10.1629 -0.0996274 11.3438 0.148649 12.4419 0.62033C13.5399 1.09201 14.533 1.77765 15.3632 2.63724C17.0027 4.33466 17.9098 6.60808 17.8893 8.96785C17.8688 11.3276 16.9223 13.5849 15.2536 15.2536C13.5849 16.9223 11.3276 17.8688 8.96785 17.8893C6.60808 17.9098 4.33466 17.0027 2.63724 15.3632ZM14.0942 14.0942C15.4453 12.7432 16.2042 10.9109 16.2042 9.00024C16.2042 7.08962 15.4453 5.25726 14.0942 3.90624C12.7432 2.55523 10.9109 1.79624 9.00024 1.79624C7.08962 1.79624 5.25726 2.55523 3.90624 3.90624C2.55523 5.25726 1.79624 7.08962 1.79624 9.00024C1.79624 10.9109 2.55523 12.7432 3.90624 14.0942C5.25726 15.4453 7.08962 16.2042 9.00024 16.2042C10.9109 16.2042 12.7432 15.4453 14.0942 14.0942ZM8.10024 4.50024H9.90024V9.90024H8.10024V4.50024ZM8.10024 11.7002H9.90024V13.5002H8.10024V11.7002Z"
          fill={props.color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1009_1993">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  CircleCheck: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM11.768 15.64L16.768 9.64L15.232 8.36L10.932 13.519L8.707 11.293L7.293 12.707L10.293 15.707L11.067 16.481L11.768 15.64Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Category: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 10C18.6569 10 20 8.65685 20 7C20 5.34315 18.6569 4 17 4C15.3431 4 14 5.34315 14 7C14 8.65685 15.3431 10 17 10Z"
        stroke={props.color || 'currentColor'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 20C8.65685 20 10 18.6569 10 17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17C4 18.6569 5.34315 20 7 20Z"
        stroke={props.color || 'currentColor'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 14H20V19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H15C14.7348 20 14.4804 19.8946 14.2929 19.7071C14.1054 19.5196 14 19.2652 14 19V14ZM4 4H10V9C10 9.26522 9.89464 9.51957 9.70711 9.70711C9.51957 9.89464 9.26522 10 9 10H5C4.73478 10 4.48043 9.89464 4.29289 9.70711C4.10536 9.51957 4 9.26522 4 9V4Z"
        stroke={props.color || 'currentColor'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  WorkInfoBaseImg: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.50497 14H8.50497V15H3.50497V14ZM4.50497 16H7.50497V17H4.50497V16ZM6.00497 3C4.67888 3 3.40711 3.52678 2.46943 4.46447C1.53175 5.40215 1.00497 6.67392 1.00497 8C0.971154 8.72667 1.11035 9.45098 1.41111 10.1133C1.71188 10.7757 2.1656 11.3572 2.73497 11.81C3.23497 12.275 3.50497 12.54 3.50497 13H4.50497C4.50497 12.08 3.94997 11.565 3.40997 11.07C2.94265 10.7121 2.5702 10.2451 2.32526 9.70992C2.08031 9.1747 1.97034 8.58759 2.00497 8C2.00497 6.93913 2.42639 5.92172 3.17654 5.17157C3.92669 4.42143 4.9441 4 6.00497 4C7.06583 4 8.08325 4.42143 8.83339 5.17157C9.58354 5.92172 10.005 6.93913 10.005 8C10.039 8.58802 9.92828 9.17541 9.68244 9.71067C9.43661 10.2459 9.0632 10.7127 8.59497 11.07C8.05997 11.57 7.50497 12.07 7.50497 13H8.50497C8.50497 12.54 8.76997 12.275 9.27497 11.805C9.84394 11.353 10.2975 10.7724 10.5982 10.1109C10.899 9.44935 11.0384 8.72589 11.005 8C11.005 7.34339 10.8756 6.69321 10.6244 6.08658C10.3731 5.47995 10.0048 4.92876 9.5405 4.46447C9.07621 4.00017 8.52501 3.63188 7.91838 3.3806C7.31176 3.12933 6.66158 3 6.00497 3Z"
        fill={props.color || 'currentColor'}
      />
      <path
        d="M6.88723 1.99167C8.59312 2.4 9.82841 3.91667 9.82841 5.66667V6.25H10.4166C10.7696 6.25 11.0049 6.48333 11.0049 6.83333V7.41667C11.0049 7.76667 10.7696 8 10.4166 8H1.59312C1.24018 8 1.00488 7.76667 1.00488 7.41667V6.83333C1.00488 6.48333 1.24018 6.25 1.59312 6.25H2.18135V5.66667C2.18135 3.91667 3.41665 2.4 5.12253 1.99167V1.58334C5.12253 1.23334 5.35782 1 5.71076 1H6.299C6.65194 1 6.88723 1.23334 6.88723 1.58334V1.99167Z"
        fill="white"
      />
      <path
        d="M6.88723 1.99167C8.59312 2.4 9.82841 3.91667 9.82841 5.66667V6.25M6.88723 1.99167V1.58334C6.88723 1.23334 6.65194 1 6.299 1H5.71076C5.35782 1 5.12253 1.23334 5.12253 1.58334V1.99167M6.88723 1.99167V6.25M9.82841 6.25H6.88723M9.82841 6.25H10.4166C10.7696 6.25 11.0049 6.48333 11.0049 6.83333V7.41667C11.0049 7.76667 10.7696 8 10.4166 8H1.59312C1.24018 8 1.00488 7.76667 1.00488 7.41667V6.83333C1.00488 6.48333 1.24018 6.25 1.59312 6.25H2.18135M5.12253 6.25V1.99167M5.12253 6.25H2.18135M5.12253 6.25H6.88723M5.12253 1.99167C3.41665 2.4 2.18135 3.91667 2.18135 5.66667V6.25"
        stroke={props.color || 'currentColor'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Camera: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.778 21H14.222C17.343 21 18.904 21 20.025 20.265C20.5088 19.9482 20.9254 19.5391 21.251 19.061C22 17.961 22 16.428 22 13.364C22 10.3 22 8.76705 21.251 7.66705C20.9254 7.18904 20.5088 6.77991 20.025 6.46305C19.305 5.99005 18.403 5.82105 17.022 5.76105C16.363 5.76105 15.796 5.27105 15.667 4.63605C15.5684 4.17092 15.3123 3.75408 14.9418 3.456C14.5714 3.15791 14.1095 2.99686 13.634 3.00005H10.366C9.378 3.00005 8.527 3.68505 8.333 4.63605C8.204 5.27105 7.637 5.76105 6.978 5.76105C5.598 5.82105 4.696 5.99105 3.975 6.46305C3.49154 6.78001 3.07527 7.18914 2.75 7.66705C2 8.76705 2 10.299 2 13.364C2 16.429 2 17.96 2.749 19.061C3.073 19.537 3.489 19.946 3.975 20.265C5.096 21 6.657 21 9.778 21ZM12 9.27305C9.699 9.27305 7.833 11.104 7.833 13.363C7.833 15.622 9.7 17.456 12 17.456C14.3 17.456 16.167 15.624 16.167 13.365C16.167 11.106 14.3 9.27305 12 9.27305ZM12 10.909C10.62 10.909 9.5 12.008 9.5 13.364C9.5 14.719 10.62 15.818 12 15.818C13.38 15.818 14.5 14.719 14.5 13.364C14.5 12.009 13.38 10.909 12 10.909ZM16.722 10.091C16.722 9.63905 17.095 9.27305 17.556 9.27305H18.666C19.126 9.27305 19.5 9.63905 19.5 10.091C19.4979 10.3099 19.409 10.5191 19.2528 10.6724C19.0966 10.8258 18.8859 10.9109 18.667 10.909H17.556C17.4475 10.9101 17.3399 10.8898 17.2393 10.8492C17.1387 10.8087 17.047 10.7487 16.9696 10.6728C16.8921 10.5968 16.8304 10.5064 16.7879 10.4065C16.7454 10.3067 16.723 10.1995 16.722 10.091Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Trash: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Pencil: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.71 7.04006C21.1 6.65006 21.1 6.00006 20.71 5.63006L18.37 3.29006C18 2.90006 17.35 2.90006 16.96 3.29006L15.12 5.12006L18.87 8.87006M3 17.2501V21.0001H6.75L17.81 9.93006L14.06 6.18006L3 17.2501Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Emergency: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99977 4.28906C12.0967 4.28906 14.6072 6.79957 14.6072 9.89648V13.9922C14.6072 14.1414 14.5479 14.2844 14.4424 14.3899C14.3369 14.4954 14.1939 14.5547 14.0447 14.5547H3.95485C3.80566 14.5547 3.66259 14.4954 3.5571 14.3899C3.45161 14.2844 3.39235 14.1414 3.39235 13.9922V9.89648C3.39235 6.79957 5.90285 4.28906 8.99977 4.28906ZM8.50758 1.19531H9.49196C9.52925 1.19531 9.56502 1.21013 9.59139 1.2365C9.61777 1.26287 9.63258 1.29864 9.63258 1.33594V3.02344C9.63258 3.06073 9.61777 3.0965 9.59139 3.12287C9.56502 3.14925 9.52925 3.16406 9.49196 3.16406H8.50758C8.47028 3.16406 8.43452 3.14925 8.40814 3.12287C8.38177 3.0965 8.36696 3.06073 8.36696 3.02344V1.33594C8.36696 1.29864 8.38177 1.26287 8.40814 1.2365C8.43452 1.21013 8.47028 1.19531 8.50758 1.19531ZM3.11549 3.36902C3.12855 3.35595 3.14406 3.34558 3.16113 3.3385C3.1782 3.33142 3.1965 3.32778 3.21498 3.32778C3.23346 3.32778 3.25176 3.33142 3.26883 3.3385C3.28591 3.34558 3.30142 3.35595 3.31448 3.36902L4.50768 4.56223C4.53403 4.5886 4.54883 4.62435 4.54883 4.66163C4.54883 4.69891 4.53403 4.73467 4.50768 4.76104L3.81159 5.45713C3.78522 5.48348 3.74946 5.49828 3.71218 5.49828C3.6749 5.49828 3.63915 5.48348 3.61278 5.45713L2.41957 4.26393C2.39322 4.23756 2.37842 4.2018 2.37842 4.16452C2.37842 4.12724 2.39322 4.09149 2.41957 4.06512L3.11567 3.36902H3.11549ZM14.8858 3.36902L15.5819 4.06512C15.6082 4.09148 15.623 4.1272 15.623 4.16443C15.623 4.20167 15.6082 4.23739 15.5819 4.26375L14.3887 5.4573C14.3756 5.47038 14.3601 5.48075 14.3431 5.48783C14.326 5.49491 14.3077 5.49855 14.2892 5.49855C14.2707 5.49855 14.2524 5.49491 14.2354 5.48783C14.2183 5.48075 14.2028 5.47038 14.1897 5.4573L13.4936 4.76121C13.4805 4.74815 13.4702 4.73264 13.4631 4.71557C13.456 4.6985 13.4524 4.6802 13.4524 4.66172C13.4524 4.64324 13.456 4.62494 13.4631 4.60787C13.4702 4.5908 13.4805 4.57529 13.4936 4.56223L14.687 3.36902C14.7134 3.34267 14.7491 3.32787 14.7864 3.32787C14.8237 3.32787 14.8594 3.34267 14.8858 3.36902ZM3.37477 15.6797H14.6248C14.774 15.6797 14.917 15.739 15.0225 15.8444C15.128 15.9499 15.1873 16.093 15.1873 16.2422V16.6641C15.1873 16.7014 15.1725 16.7371 15.1461 16.7635C15.1197 16.7899 15.0839 16.8047 15.0466 16.8047H2.95289C2.9156 16.8047 2.87983 16.7899 2.85346 16.7635C2.82708 16.7371 2.81227 16.7014 2.81227 16.6641V16.2422C2.81227 16.093 2.87153 15.9499 2.97702 15.8444C3.08251 15.739 3.22558 15.6797 3.37477 15.6797ZM5.97633 10.1074V14.5547H7.10133V10.1074H5.97633Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  ArrowDropDown: (props) => (
    <svg
      width={props.width || '16'}
      height={props.height || '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.63605 5.29246C1.82358 5.10499 2.07788 4.99968 2.34305 4.99968C2.60821 4.99968 2.86252 5.10499 3.05005 5.29246L8.00005 10.2425L12.95 5.29246C13.1387 5.11031 13.3913 5.00951 13.6535 5.01179C13.9156 5.01407 14.1665 5.11924 14.3519 5.30465C14.5373 5.49005 14.6424 5.74087 14.6447 6.00306C14.647 6.26526 14.5462 6.51786 14.364 6.70646L8.70705 12.3635C8.51952 12.5509 8.26521 12.6562 8.00005 12.6562C7.73488 12.6562 7.48058 12.5509 7.29305 12.3635L1.63605 6.70646C1.44858 6.51894 1.34326 6.26463 1.34326 5.99946C1.34326 5.7343 1.44858 5.47999 1.63605 5.29246Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Setting: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '16'}
      height={props.height || '16'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm112-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z" />
    </svg>
  ),
  Alarm: (props) => (
    <svg
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.71286 21.6231H23.2869C24.4004 21.6231 25.0569 21.0491 25.0569 20.2051C25.0569 19.0331 23.8729 17.9786 22.8534 16.9356C22.0799 16.1271 21.8689 14.4631 21.7869 13.1156C21.6934 8.61558 20.5099 5.51008 17.3809 4.38508C16.9474 2.86158 15.7284 1.64258 14.0059 1.64258C12.2709 1.64258 11.0644 2.86158 10.6189 4.38508C7.50186 5.51008 6.30636 8.61508 6.22436 13.1151C6.13086 14.4631 5.93136 16.1271 5.14636 16.9356C4.13836 17.9786 2.94336 19.0331 2.94336 20.2056C2.94336 21.0491 3.61136 21.6231 4.71286 21.6231ZM10.4314 23.2171C10.5724 24.9281 12.0134 26.3571 14.0059 26.3571C15.9859 26.3571 17.4274 24.9281 17.5799 23.2171H10.4314Z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),

  // 메뉴 아이콘
  LightMode: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M565-395q35-35 35-85t-35-85q-35-35-85-35t-85 35q-35 35-35 85t35 85q35 35 85 35t85-35Zm-226.5 56.5Q280-397 280-480t58.5-141.5Q397-680 480-680t141.5 58.5Q680-563 680-480t-58.5 141.5Q563-280 480-280t-141.5-58.5ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z" />
    </svg>
  ),
  Notifications: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 0 24 24"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
    </svg>
  ),
  GridView: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M120-120v-320h320v320H120Zm0-400v-320h320v320H120Zm400 400v-320h320v320H520Zm0-400v-320h320v320H520Z" />
    </svg>
  ),

  PlayCircle: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m380-300 280-180-280-180v360ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),

  Groups: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Z" />
    </svg>
  ),

  Lightbulb: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M423.5-103.5Q400-127 400-160h160q0 33-23.5 56.5T480-80q-33 0-56.5-23.5ZM320-200v-80h320v80H320Zm10-120q-69-41-109.5-110T180-580q0-125 87.5-212.5T480-880q125 0 212.5 87.5T780-580q0 81-40.5 150T630-320H330Z" />
    </svg>
  ),

  TaskAlt: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z" />
    </svg>
  ),

  FolderOpen: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640H160v400l96-320h684L837-217q-8 26-29.5 41.5T760-160H160Z" />
    </svg>
  ),

  Description: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520h200L520-800v200Z" />
    </svg>
  ),

  ChevronRight: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
    </svg>
  ),

  Home: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" />
    </svg>
  ),

  FormatListBulleted: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M360-200v-80h480v80H360Zm0-240v-80h480v80H360Zm0-240v-80h480v80H360ZM200-160q-33 0-56.5-23.5T120-240q0-33 23.5-56.5T200-320q33 0 56.5 23.5T280-240q0 33-23.5 56.5T200-160Zm0-240q-33 0-56.5-23.5T120-480q0-33 23.5-56.5T200-560q33 0 56.5 23.5T280-480q0 33-23.5 56.5T200-400Zm-56.5-263.5Q120-687 120-720t23.5-56.5Q167-800 200-800t56.5 23.5Q280-753 280-720t-23.5 56.5Q233-640 200-640t-56.5-23.5Z" />
    </svg>
  ),

  Warning: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm330.5-51.5Q520-263 520-280t-11.5-28.5Q497-320 480-320t-28.5 11.5Q440-297 440-280t11.5 28.5Q463-240 480-240t28.5-11.5ZM440-360h80v-200h-80v200Zm40-100Z" />
    </svg>
  ),

  Person: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm296.5-343.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-640Zm0 400Z" />
    </svg>
  ),
  Engineering: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '28'}
      height={props.height || '28'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M42-120v-112q0-33 17-62t47-44q51-26 115-44t141-18q77 0 141 18t115 44q30 15 47 44t17 62v112H42Zm207-367q-47-47-47-113h-10q-9 0-14.5-5.5T172-620q0-9 5.5-14.5T192-640h10q0-45 22-81t58-57v38q0 9 5.5 14.5T302-720q9 0 14.5-5.5T322-740v-54q9-3 19-4.5t21-1.5q11 0 21 1.5t19 4.5v54q0 9 5.5 14.5T422-720q9 0 14.5-5.5T442-740v-38q36 21 58 57t22 81h10q9 0 14.5 5.5T552-620q0 9-5.5 14.5T532-600h-10q0 66-47 113t-113 47q-66 0-113-47Zm169.5-56.5Q442-567 442-600H282q0 33 23.5 56.5T362-520q33 0 56.5-23.5ZM662-360l-6-30q-6-2-11.5-4.5T634-402l-28 10-20-36 22-20v-24l-22-20 20-36 28 10q4-4 10-7t12-5l6-30h40l6 30q6 2 12 5t10 7l28-10 20 36-22 20v24l22 20-20 36-28-10q-5 5-10.5 7.5T708-390l-6 30h-40Zm41-79q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm51-121-8-42q-9-3-16.5-7.5T716-620l-42 14-28-48 34-30q-2-5-2-8v-16q0-3 2-8l-34-30 28-48 42 14q6-6 13.5-10.5T746-798l8-42h56l8 42q9 3 16.5 7.5T848-780l42-14 28 48-34 30q2 5 2 8v16q0 3-2 8l34 30-28 48-42-14q-6 6-13.5 10.5T818-602l-8 42h-56Zm63.5-104.5Q832-679 832-700t-14.5-35.5Q803-750 782-750t-35.5 14.5Q732-721 732-700t14.5 35.5Q761-650 782-650t35.5-14.5Z" />
    </svg>
  ),
  Siren: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M320-440h80v-120q0-33 23.5-56.5T480-640v-80q-66 0-113 47t-47 113v120ZM160-120q-33 0-56.5-23.5T80-200v-80q0-33 23.5-56.5T160-360h40v-200q0-117 81.5-198.5T480-840q117 0 198.5 81.5T760-560v200h40q33 0 56.5 23.5T880-280v80q0 33-23.5 56.5T800-120H160Z" />
    </svg>
  ),
  Campaign: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z" />
    </svg>
  ),
  Inventory: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M620-163 450-333l56-56 114 114 226-226 56 56-282 282Zm220-397h-80v-200h-80v120H280v-120h-80v560h240v80H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v200ZM508.5-771.5Q520-783 520-800t-11.5-28.5Q497-840 480-840t-28.5 11.5Q440-817 440-800t11.5 28.5Q463-760 480-760t28.5-11.5Z" />
    </svg>
  ),
  ChefHat: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M360-400h80v-200h-80v200Zm-160-60q-46-23-73-66.5T100-621q0-75 51.5-127T278-800q12 0 24.5 2t24.5 5q25-41 65-64t88-23q48 0 88 23t65 64q12-3 24-5t25-2q75 0 126.5 52T860-621q0 51-27 94.5T760-460v220H200v-220Zm320 60h80v-200h-80v200Zm-240 80h400v-189l44-22q26-13 41-36.5t15-52.5q0-42-28.5-71T682-720q-11 0-20 2t-19 5l-47 13-31-52q-14-23-36.5-35.5T480-800q-26 0-48.5 12.5T395-752l-31 52-48-13q-10-2-19.5-4.5T277-720q-41 0-69 29t-28 71q0 29 15 52.5t41 36.5l44 22v189Zm-80 80h80v80h400v-80h80v160H200v-160Zm280-80Z" />
    </svg>
  ),
  VerifiedUser: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m438-338 226-226-57-57-169 169-84-84-57 57 141 141Zm42 258q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Z" />
    </svg>
  ),
  HardHat: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 18V15C19.9968 13.4092 19.5194 11.8555 18.6287 10.5373C17.7381 9.21922 16.4747 8.19655 15 7.6V13H14V5H10V13H9V7.6C7.52528 8.19655 6.2619 9.21922 5.37127 10.5373C4.48065 11.8555 4.00322 13.4092 4 15V18H2V20H22V18H20Z"
        fill={props.color || 'currentColor'}
        {...props}
      />
    </svg>
  ),
  ToolTip: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM480-80 373-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H587L480-80Z" />
    </svg>
  ),

  //  날씨 아이콘

  Rainy: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M558-84q-15 8-30.5 2.5T504-102l-60-120q-8-15-2.5-30.5T462-276q15-8 30.5-2.5T516-258l60 120q8 15 2.5 30.5T558-84Zm240 0q-15 8-30.5 2.5T744-102l-60-120q-8-15-2.5-30.5T702-276q15-8 30.5-2.5T756-258l60 120q8 15 2.5 30.5T798-84Zm-480 0q-15 8-30.5 2.5T264-102l-60-120q-8-15-2.5-30.5T222-276q15-8 30.5-2.5T276-258l60 120q8 15 2.5 30.5T318-84Zm-18-236q-91 0-155.5-64.5T80-540q0-83 55-145t136-73q32-57 87.5-89.5T480-880q90 0 156.5 57.5T717-679q69 6 116 57t47 122q0 75-52.5 127.5T700-320H300Zm0-80h400q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-40q0-66-47-113t-113-47q-48 0-87.5 26T333-704l-10 24h-25q-57 2-97.5 42.5T160-540q0 58 41 99t99 41Zm180-200Z" />
    </svg>
  ),
  Cloud: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M260-160q-91 0-155.5-63T40-377q0-78 47-139t123-78q25-92 100-149t170-57q117 0 198.5 81.5T760-520q69 8 114.5 59.5T920-340q0 75-52.5 127.5T740-160H260Zm0-80h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-83-58.5-141.5T480-720q-83 0-141.5 58.5T280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41Zm220-240Z" />
    </svg>
  ),
  CheckCircle: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  AssignmentTurned: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m424-318 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm301.5-678.5Q510-807 510-820t-8.5-21.5Q493-850 480-850t-21.5 8.5Q450-833 450-820t8.5 21.5Q467-790 480-790t21.5-8.5Z" />
    </svg>
  ),
  Schedule: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  /** 위험감지·아차사고 (RIN_BASIC) — 삼각 경고 + 느낌표 */
  RiskNearMiss: (props) => (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  ),
  Clock: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  Location: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
    </svg>
  ),
  Corporate: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M80-120v-720h400v160h400v560H80Zm80-80h240v-80H160v80Zm0-160h240v-80H160v80Zm0-160h240v-80H160v80Zm0-160h240v-80H160v80Zm320 480h320v-400H480v400Zm80-240v-80h160v80H560Zm0 160v-80h160v80H560Z" />
    </svg>
  ),
  Cancel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
    </svg>
  ),
  Assignment: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q14-36 44-58t68-22q38 0 68 22t44 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm301.5-678.5Q510-807 510-820t-8.5-21.5Q493-850 480-850t-21.5 8.5Q450-833 450-820t8.5 21.5Q467-790 480-790t21.5-8.5ZM579-481q41-41 41-99t-41-99q-41-41-99-41t-99 41q-41 41-41 99t41 99q41 41 99 41t99-41ZM200-200h560v-46q-54-53-125.5-83.5T480-360q-83 0-154.5 30.5T200-246v46Z" />
    </svg>
  ),
  Notes: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M120-240v-80h480v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
    </svg>
  ),
  ArrowBottom: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
    </svg>
  ),
  Verified: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="m438-338 226-226-57-57-169 169-84-84-57 57 141 141Zm42 258q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Z" />
    </svg>
  ),
  ArrowForward: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" />
    </svg>
  ),
  Info: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M440-280h80v-240h-80v240Zm68.5-331.5Q520-623 520-640t-11.5-28.5Q497-680 480-680t-28.5 11.5Q440-657 440-640t11.5 28.5Q463-600 480-600t28.5-11.5ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  ),
  MenuBook: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      viewBox="0 -960 960 960"
      fill={props.color || 'currentColor'}
      {...props}
    >
      <path d="M560-564v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-600q-38 0-73 9.5T560-564Zm0 220v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-380q-38 0-73 9t-67 27Zm0-110v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-490q-38 0-73 9.5T560-454ZM260-320q47 0 91.5 10.5T440-278v-394q-41-24-87-36t-93-12q-36 0-71.5 7T120-692v396q35-12 69.5-18t70.5-6Zm260 42q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 102 12t96 36q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59ZM280-494Z" />
    </svg>
  ),
};

export default Icon;
